export default {
  free: 'GRATUIT',
  save: 'Economisești {{amount}}',
};
